import { render } from "./IftarCombo.vue?vue&type=template&id=506f15f7&scoped=true"
import script from "./IftarCombo.vue?vue&type=script&lang=js"
export * from "./IftarCombo.vue?vue&type=script&lang=js"

import "./IftarCombo.vue?vue&type=style&index=0&id=506f15f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506f15f7"]])

export default __exports__